
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
@Component({})
export default class LumpAFEPerformanceBudget extends Vue {
    @Prop({ default: () => [] })
    rows!: Array<any>;
    @Prop({ default: () => [] })
    activeProjectConversionFactor!: number;
    @Prop({ default: () => [] })
    lineSplit!: number;
    @Prop({ default: () => [] })
    disabled!: boolean;
    
    forceReload = 0;

    updateLineSum(afeCost: any) {
      this.$emit('lineValueChanged', {afeCost})
    }

    calculateTotalPlan(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.plan || 0), 0);
    }

    calculateTotalAFECost(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.afeCost || 0), 0);
    }

    calculateTotalActualDailyCumCost(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.actualDailyCumulativeCost || 0), 0);
    }

    calculateTotalVarianceCost(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.variance || 0), 0);
    }

    mounted() {
      this.forceReload += 1;
    }
}
